/* Pure cart rules shared by the storefront and the experiment regression tests. */
((root, factory) => {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.FieldSignalExperimentCore = api;
})(typeof window === 'undefined' ? globalThis : window, () => {
  function repairs(cart, mapping) {
    const updates = {};
    const additions = [];
    const items = cart.items || [];
    const freeIds = new Set(Object.values(mapping).map((plan) => Number(plan.freeId)).filter(Boolean));
    const parentKey = (item) => item.parent_relationship?.parent?.key || item.parent_relationship?.parent_key;
    for (const item of items) {
      if (freeIds.has(Number(item.variant_id))) {
        const parent = items.find((candidate) => candidate.key === parentKey(item));
        if (!parent || Number(mapping[parent.variant_id]?.freeId) !== Number(item.variant_id)) updates[item.key] = 0;
      }
    }
    for (const parent of items) {
      const plan = mapping[parent.variant_id];
      if (!plan || parentKey(parent)) continue;
      if (!plan.freeId || plan.freePrice !== 0 || !plan.available) {
        throw new Error('Free protection is temporarily unavailable. Please refresh or contact us before ordering.');
      }
      const children = items.filter((item) => parentKey(item) === parent.key);
      let found = false;
      for (const child of children) {
        if (Number(child.variant_id) === Number(plan.paidId)) updates[child.key] = 0;
        if (Number(child.variant_id) !== Number(plan.freeId)) continue;
        if (Number(child.original_price ?? child.price) !== 0) {
          throw new Error('We could not confirm free protection. Please refresh or contact us before ordering.');
        }
        if (found) updates[child.key] = 0;
        else {
          found = true;
          if (child.quantity !== parent.quantity) updates[child.key] = parent.quantity;
        }
      }
      if (!found) additions.push({ id: Number(plan.freeId), quantity: parent.quantity, parent_line_key: parent.key });
    }
    return { updates, additions };
  }
  return { repairs };
});
